import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import useDateRange from "hooks/useDateRange";
import DateRange from "components/ui/date-range";
import SynthpopMetrics from "features/synthpop/synthpop-metrics";
import "features/synthpop/agent-calling-dashboard.scss";

const CompanyAICallMetrics = ({ params }) => {
  const { startDate, endDate, setStartDate, setEndDate, dateRangeIsValid } =
    useDateRange({
      startDate: moment().subtract(7, "days").format("MM/DD/YYYY"),
      endDate: moment().format("MM/DD/YYYY")
    });

  return (
    <div className="agent-calling-dashboard">
      <div className="company-ai-call-metrics-header">
        <DateRange
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          isValid={dateRangeIsValid}
          showSubmit={false}
        />
      </div>
      <SynthpopMetrics
        startDate={startDate}
        endDate={endDate}
        companyGuid={params.id}
      />
    </div>
  );
};

CompanyAICallMetrics.propTypes = {
  params: PropTypes.shape({ id: PropTypes.string })
};

export default CompanyAICallMetrics;
